module.exports = "/assets/8fb152d0da3463ecc61884b193495ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MF.png
// module id = 1612
// module chunks = 0